import { render } from "./club-edit.vue?vue&type=template&id=1d1cc10a"
import script from "./club-edit.vue?vue&type=script&lang=js"
export * from "./club-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__